import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchTools } from "../lib/api";

// A compact inline strip of related tool chips for placement near the top
export default function RelatedToolsStrip({ currentSlug, category }) {
    const [tools, setTools] = useState([]);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const list = await fetchTools({ category });
                const filtered = list
                    .filter((t) => t.slug !== currentSlug)
                    .slice(0, 7);
                if (!cancelled) setTools(filtered);
            } catch {
                /* ignore */
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [currentSlug, category]);

    if (tools.length === 0) return null;

    return (
        <div
            data-testid="related-tools-strip"
            className="mt-5 flex flex-wrap items-center gap-2"
        >
            <span className="text-xs font-bold uppercase tracking-widest text-neutral-700 mr-1">
                Related:
            </span>
            {tools.map((t) => (
                <Link
                    key={t.slug}
                    to={`/tool/${t.slug}`}
                    data-testid={`strip-tool-${t.slug}`}
                    className="nb-border bg-white text-black text-xs font-bold px-3 py-1.5 rounded-full hover:bg-[#FDE047] hover:-translate-y-[2px] hover:shadow-[2px_2px_0px_#0A0A0A] active:translate-y-[2px] active:translate-x-[2px] active:shadow-none transition-all"
                >
                    {t.name}
                </Link>
            ))}
        </div>
    );
}
